export const FRAGEMENT_META = `
id
key
value
section
type
`

export const FRAGEMENT_POST = `
id
slug
type
order
title_id
title_en
featured
excerpt_id
excerpt_en
content_id
content_en
thumb_image
published_at
featured_image
report_year
`
export const FRAGEMENT_POST_CATEGORIES = `
id
slug
type
title_id
title_en
description_id
description_en
thumb_image
featured_image
have_own_location
`
export const FRAGMENT_POST_PAGINATION = `
count
firstItem
lastItem
currentPage
perPage
lastPage
total
hasMorePages
`
export const FRAGMENT_JOB = `
id
slug
title_id
title_en
content_id
content_en
type
cta_url
location {
  id
  name
}
`

export const FRAGMENT_OUTLET = `
    id
    slug
    is_3d
    is_thx
    is_dolby_atmos
    title_id
    title_en
    content_id
    content_en
    excerpt_id
    excerpt_en
    city {
      id
      name
    }
    status
    published_at
    created_at
    featured_image
    thumb_image
    updated_at
    address
    concessions {
      id
      title_id
      title_en
      description_id
      description_en
      slug
      featured_image
      thumb_image
    }
    cinemas {
      id
      title_id
      title_en
      description_id
      description_en
      slug
      featured_image
      thumb_image
    }
`
